import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { boardingTabs, BoardingTabId } from './BoardingTabs';
import styles from './BoardingNavbar.module.scss';

interface BoardingNavbarProps {
    selectedTab: BoardingTabId;
    onTabChange: (tabId: BoardingTabId) => void;
}

export const BoardingNavbar: React.FC<BoardingNavbarProps> = ({ selectedTab, onTabChange }) => {
    return (
        <div className={styles.root}>
            <p className={styles.title}>Boarding</p>

            <nav className={styles.menu}>
                {boardingTabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={styles.menuLink}
                        aria-current={selectedTab === tab.id ? 'page' : undefined}
                    >
                        <FontAwesomeIcon icon={tab.icon} />
                        {tab.name}
                    </button>
                ))}
            </nav>
        </div>
    );
};
